//ADD PACKAGE
export const ADD_WEIGHTCALC_REQUEST = "ADD_PACKAGE_REQUEST";
export const ADD_WEIGHTCALC_SUCCESS = "ADD_PACKAGE_SUCCESS";
export const ADD_WEIGHTCALC_FAILURE = "ADD_PACKAGE_FAILURE";

//UPDATE PACKAGE
export const UPDATE_WEIGHTCALC_REQUEST = "UPDATE_PACKAGE_REQUEST";
export const UPDATE_WEIGHTCALC_SUCCESS = "UPDATE_PACKAGE_SUCCESS";
export const UPDATE_WEIGHTCALC_FAILURE = "UPDATE_PACKAGE_FAILURE";

//DELETE PACKAGE
export const DELETE_WEIGHTCALC_REQUEST = "DELETE_PACKAGE_REQUEST";
export const DELETE_WEIGHTCALC_SUCCESS = "DELETE_PACKAGE_SUCCESS";
export const DELETE_WEIGHTCALC_FAILURE = "DELETE_PACKAGE_FAILURE";

//GET PACKAGE LIST
export const GET_WEIGHTCALC_REQUEST = "GET_PACKAGE_REQUEST";
export const GET_WEIGHTCALC_SUCCESS = "GET_PACKAGE_SUCCESS";
export const GET_WEIGHTCALC_FAILURE = "GET_PACKAGE_FAILURE";
